<template>
  <v-container class="px-1 pa-sm-5 blog-listing">
    <v-row v-if="$apollo.queries.posts.loading">
      <v-col :cols="12" :md="6" :lg="4" :xl="3" v-for="i in 5" :key="i">
        <v-skeleton-loader
          elevation="1"
          type="image, article, list-item-avatar-three-line"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col :cols="12" :md="6" :lg="4" :xl="3" v-for="post in posts.edges" :key="post.id">
        <v-card class="mx-auto" max-width="400" :to="{ name: 'blogArticle', params: {slug: post.node.slug} }">
          <v-img class="white--text align-end" height="200px" :src="post.node.featuredImage.node.mediaItemUrl" v-if="post.node.featuredImage"></v-img>
          <v-card-subtitle class="text-break pb-0 d-flex">
            <div v-for="category in post.node.categories.nodes" :key="category.id" class="pr-1 category success--text">
              {{ category.name }}
            </div>
          </v-card-subtitle>
          <div class="d-flex flex-column excerpt">
            <v-card-title class="text-break">{{ post.node.title }}</v-card-title>
            <v-card-text class="text--primary sub">
              {{ sanitize(post.node.excerpt) }}
            </v-card-text>
          </div>
          <div>
            <v-card-text class="py-0">
              {{ post.node.author.node.name }}
            </v-card-text>
            <v-card-subtitle class="pt-0">
              {{ post.node.date | moment('MMMM D, YYYY') }}
            </v-card-subtitle>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import GET_POSTS from '../../graphql/blog/list.graphql'
// eslint-disable-next-line no-unused-vars
import sanitizeHtml from 'sanitize-html'

export default {
  data () {
    return {
      first: 100,
      after: ''
    }
  },
  methods: {
    sanitize (html) {
      return sanitizeHtml(html, {
        allowedTags: [],
        textFilter: function (text, tagName) {
          return tagName === 'a' ? '' : text
        }
      })
    }
  },
  apollo: {
    $client: 'b',
    posts: {
      query: GET_POSTS,
      variables () {
        return {
          first: this.first,
          after: this.after
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .excerpt {
    min-height: 251px;
    .sub {
      font-family: $blog-font-family;
      font-size: 1.2rem;
      line-height: 1.4;
    }
  }
  .author {
    font-weight: 500;
  }
  .category {
    font-weight: 500;
    text-transform: uppercase;
    font-size: 12px;
    &:not(:last-child) {
      &:after {
        content: '|';
        margin-right: 0;
      }
    }
  }
</style>
